import React from 'react';
import './styles.css';
import {notificationsText} from '../notificationsText';
import {
  NOTIFICATION_COURSE_ENROLLMENT,
  NOTIFICATION_COURSE_INSTRUCTION,
  NOTIFICATION_STAFF_INVITATION,
} from '../../../data/models/Notifications/Invitation';

interface Props {
  description: string;
  title: string;
  dateSubtitle: string;
  icon?: string;
  type: number;
  onViewCourse: () => void;
  onViewCoursePreview: () => void;
  onViewWorkspace: () => void;
}

const InvitationNotifcationPopUp = React.memo(
  ({
    description,
    title,
    dateSubtitle,
    icon,
    type,
    onViewCourse,
    onViewWorkspace,
    onViewCoursePreview,
  }: Props) => {
    return (
      <>
        {icon && (
          <button
            className="ProfilePicture"
            style={{backgroundImage: `url(${icon})`}}
          />
        )}
        <div className="TextContainer">
          {title && <p>{title}</p>}
          {description && <p>{description}</p>}
          <p className="SubtitleText">{dateSubtitle}</p>
          {type === NOTIFICATION_STAFF_INVITATION && (
            <div className="ButtonContainer">
              <button className="AcceptButton" onClick={onViewWorkspace}>
                {notificationsText.viewWorkspace}
              </button>
            </div>
          )}
          {type === NOTIFICATION_COURSE_ENROLLMENT && (
            <div className="ButtonContainer">
              <button className="AcceptButton" onClick={onViewCourse}>
                {notificationsText.viewCourse}
              </button>
            </div>
          )}
          {type === NOTIFICATION_COURSE_INSTRUCTION && (
            <div className="ButtonContainer">
              <button className="AcceptButton" onClick={onViewCoursePreview}>
                {notificationsText.viewCourse}
              </button>
            </div>
          )}
          {/* {(type === NOTIFICATION_VIDEO_GENERATED ||
            type === NOTIFICATION_LESSON_GENERATED) && (
            <div className="ButtonContainer">
              <button onClick={onSeenNotification}>
                {notificationsText.markAsRead}
              </button>
            </div>
          )} */}
        </div>
      </>
    );
  },
);

export default InvitationNotifcationPopUp;
